import { AnswerModel, HandleAnswersAction, SubmitAnswerFn } from '@/components/decision-tree/hooks';
import { OnItemViewedCB, Steps } from '@/components/decision-tree/types';
import { type Dispatch } from 'react';

export enum PaginationActions {
  NextSurveyItem = 'NextSurveyItem',
  PreviousSurveyItem = 'PreviousSurveyItem',
  SetSurveyItemFromUrl = 'SetSurveyItemFromUrl',
}

export type NextSurveyItemType = {
  sectionId: string;
  surveyItemId: string;
};

export type CurrentPageType = {
  currentSurveyItem: string;
  currentSection: string;
};

export type PaginationPayload = {
  nextSurveyItem: NextSurveyItemType;
  nextIDontKnowAnsweredQuestion: NextSurveyItemType;
  answers: AnsweredQuestionsType;
};

export type PaginationAction = {
  type: PaginationActions;
  payload?: PaginationPayload;
};

export type PaginationState = {
  currentSurveyItem: string;
  currentSection: string;
  pageHistory: Array<NextSurveyItemType>;
  step?: number;
};

export type PaginationResponse = {
  currentPage: CurrentPageType;
  activeStep: number;
  paginationDispatch: Dispatch<PaginationAction>;
  goToNextSurveyItem: () => Promise<void>;
  showBackButton: boolean;
  isLastSurveyItem: boolean;
};

export type PaginationProps = {
  steps: Steps;
  initialState: NextSurveyItemType;
  editQuestion?: NextSurveyItemType | undefined;
  answersDispatch: Dispatch<HandleAnswersAction>;
  submitAnswer: SubmitAnswerFn;
  backOnFirstSurveyItem?: () => void;
  isUnclearQuestionsFlow: boolean;
  unclearAnswersFlow: AnsweredQuestionsType | undefined;
  isTestResultsQuestionnaire?: boolean;
  onItemViewed?: OnItemViewedCB;
};

export type AnsweredQuestionsType = Array<AnsweredQuestion>;

export type AnsweredQuestion = {
  surveyItemId: string;
  sectionId: string;
  answer: AnswerModel | undefined;
  answeredAt: string;
};
